import React from 'react';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';
import Modal from 'src/shared/components/modal/Modal';
import { SecondaryButton } from 'src/shared/components/button/Button';
import { PortfolioFrameworks } from 'src/shared/types/graph/portfolio';
import { explainerSlugKey } from 'src/shared/constants/portfolio';
import styles from './ReportingFrameworks.module.scss';
import usePortfolioSpeciesRiskAnalytics from '../../hooks/usePortfolioSpeciesRiskAnalytics';

const frameworkSlugs: { [string: string]: string } = {
    [PortfolioFrameworks.CSRD]: explainerSlugKey.portfolioCsrdFramework,
    [PortfolioFrameworks.TNFD]: explainerSlugKey.portfolioTnfdFramework,
    [PortfolioFrameworks.GRI]: explainerSlugKey.portfolioGriFramework,
};

const ReportingFrameworks = () => {
    const [selectedFramework, setSelectedFramework] = React.useState<string | null>(null);
    const trackAnalytics = usePortfolioSpeciesRiskAnalytics();

    return (
        <>
            <div className='flex items-center gap-3' data-testid='portfolio-species-risk-reporting-frameworks'>
                <span>Applicable reporting frameworks:</span>
                <div className='flex gap-1'>
                    {Object.keys(PortfolioFrameworks).map(framework => (
                        <div key={framework} className='bg-white rounded-lg'>
                            <SecondaryButton
                                key={framework}
                                className='flex items-center rounded-lg text-sm h-8'
                                onClick={() => {
                                    setSelectedFramework(framework);
                                    trackAnalytics.trackFrameworkClick();
                                }}
                            >
                                {framework}
                            </SecondaryButton>
                        </div>
                    ))}
                </div>
            </div>
            {selectedFramework && (
                <Modal
                    onClose={() => {
                        setSelectedFramework(null);
                    }}
                    dismissOnClickOutside={true}
                    classNames={{
                        body: styles.reportingFrameworksModal,
                    }}
                >
                    <CMSArticle shouldShowTitle={true} slug={frameworkSlugs[selectedFramework]} />
                </Modal>
            )}
        </>
    );
};

export default ReportingFrameworks;
